// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// https://tp.traderevolution.com/entity/109798
import { Resources } from '@shared/localizations/Resources';
import { MathUtils } from '@shared/utils/MathUtils';
import { SLTPTrigger } from '@shared/utils/SlTpTrigger';
import SLTPTriggerControlTemplate from '@front/templates/SLTPTriggerControlTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { ContainerControl } from './ContainerControl';
export class SLTPTriggerControl extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.SLTPTriggerControl;
    }
    oninit() {
        super.oninit();
        // dynProperty.sltpTriggerShort
        this.observe('value itemSettings.sltpTriggerShort', this.setRadioItemsFromSLTPTrigger);
        this.observe('side', this.onSideChange);
    }
    oncomplete() {
        super.oncomplete();
        const rbGroup = this.Controls ? this.Controls.radioComboItemGroup : null;
        if (!isNullOrUndefined(rbGroup)) {
            rbGroup.SelectedValueChanged.Subscribe(this.onRadioButtonStateChanged, this);
        }
        this.localize();
    }
    dispose() {
        const rbGroup = this.Controls ? this.Controls.radioComboItemGroup : null;
        if (!isNullOrUndefined(rbGroup)) {
            rbGroup.SelectedValueChanged.UnSubscribe(this.onRadioButtonStateChanged, this);
        }
        super.dispose();
    }
    setRadioItemsFromSLTPTrigger(triggerShort) {
        if (MathUtils.IsNullOrUndefined(triggerShort)) {
            return;
        }
        if (isNullOrUndefined(this.trigger)) {
            this.trigger = new SLTPTrigger();
        }
        const trigger = this.trigger;
        trigger.FillFromShort(triggerShort);
        const rbGroup = this.Controls ? this.Controls.radioComboItemGroup : null;
        if (!isNullOrUndefined(rbGroup)) {
            const propName = this.convertFromControlToPropertyName();
            const byBid = trigger[propName]; // true(byBid) or false(byAsk) of SLTPTrigger[propName]
            if (MathUtils.IsNullOrUndefined(byBid)) {
                // цього не повинно статися, але залишу навсяк випадок
                console.log('Wrong SLTPTrigger property name in SLTPTriggerControl.prototype.onRadioButtonStateChanged');
                return;
            }
            rbGroup.setItems(+byBid, SLTPTriggerControl.CreateRBObjVars(byBid));
        }
    }
    onRadioButtonStateChanged(rbGroup, val) {
        if (isNullOrUndefined(rbGroup))
            return;
        const isForOE = this.get('isForOE');
        const outItem = this.get(isForOE ? 'dynProperty' : 'itemSettings');
        const short = outItem ? outItem.sltpTriggerShort : null;
        if (MathUtils.IsNullOrUndefined(short)) {
            return;
        }
        if (isNullOrUndefined(this.trigger)) {
            this.trigger = new SLTPTrigger();
        }
        const tr = this.trigger.FillFromShort(short);
        const propName = this.convertFromControlToPropertyName();
        if (MathUtils.IsNullOrUndefined(tr[propName])) {
            // цього не повинно статися, але залишу навсяк випадок
            console.log('Wrong SLTPTrigger property name in SLTPTriggerControl.prototype.onRadioButtonStateChanged');
            return;
        }
        tr[propName] = !!val;
        const newValue = tr.GetShort();
        outItem.sltpTriggerShort = newValue;
        void this.set('value', newValue);
    }
    onSideChange(side) {
        if (MathUtils.IsNullOrUndefined(side)) {
            return;
        }
        void this.set('value', null); // При смене значения Side сбрасываем выбранные ранее значения SL trigger\TP trigger на дефолтовые для данной стороны
    }
    convertFromControlToPropertyName() {
        // возвращает соответствующее контролу свойство из SLTPTrigger обьекта
        return SLTPTrigger.GetPropertyName(this.get('side'), this.get('isForSL'));
    }
    localize() {
        void this.set('labelText', Resources.getResource(this.getLabelTextKey()));
    }
    getLabelTextKey() {
        // возвращает одну из строк: "property.OETPTrigger", "property.OESLTrigger" <- если контрол из OrderEntry
        // либо одну из "property.BuyTPTrigger", "property.BuySLTrigger", "property.SellTPTrigger", "property.SellSLTrigger" <- если контрол из TypesManagerScreen
        const isForOE = this.get('isForOE');
        const sideStr = this.getSideStr();
        const labelTextKey = 'property.' + (isForOE ? 'OE' : sideStr) + this.getSLTPStr() + 'Trigger';
        return labelTextKey;
    }
    getSLTPStr() {
        return SLTPTrigger.GetSLTPStr(this.get('isForSL'));
    } // returns "SL" or "TP" depending on isForSL value
    getSideStr() {
        return SLTPTrigger.GetSideStr(this.get('side'));
    } // returns "Buy" or "Sell" depending on the opposite side of order side
    static CreateRBObjVars(byBid) {
        const result = [
            { text: Resources.getResource('property.Bid'), value: 1, checked: false },
            { text: Resources.getResource('property.Ask'), value: 0, checked: false }
        ];
        if (!MathUtils.IsNullOrUndefined(byBid)) {
            result[0].checked = !!byBid;
            result[1].checked = !byBid;
        }
        return result;
    }
}
ContainerControl.extendWith(SLTPTriggerControl, {
    data: function () {
        return {
            left: 224,
            right: 50,
            width: 130,
            triggersVisible: false,
            isForOE: false, // if not it's control from TypesManager
            isForSL: null, // trigger can be for SL or TP,
            side: null, // also it have to be one of OperationType (Buy or Sell)
            labelText: null,
            value: null, // текущее значение определяющее состояния радиобатонов
            dynProperty: null, // SLTPDynProperty when in OE
            itemSettings: null // работает с TypesManager-ом, по сути itemSettings.sltpTriggerShort тоже что и value
        };
    },
    template: SLTPTriggerControlTemplate
});
